import React, { createContext, useState, useEffect } from 'react';

const AccessibilityContext = createContext();

export const AccessibilityProvider = ({ children }) => {
  const [fontSize, setFontSize] = useState(localStorage.getItem('fontSize') || 'medium');
  const [highContrast, setHighContrast] = useState(localStorage.getItem('highContrast') === 'true');
  const [reducedMotion, setReducedMotion] = useState(localStorage.getItem('reducedMotion') === 'true');

  useEffect(() => {
    // Apply font size - ensure it's applied to both html and body
    document.documentElement.setAttribute('data-font-size', fontSize);
    document.body.setAttribute('data-font-size', fontSize);
    
    // Force a repaint to ensure font size changes are applied
    document.body.style.display = 'none';
    setTimeout(() => {
      document.body.style.display = '';
    }, 5);
    
    // Apply high contrast
    if (highContrast) {
      document.documentElement.classList.add('high-contrast');
      document.body.classList.add('high-contrast');
    } else {
      document.documentElement.classList.remove('high-contrast');
      document.body.classList.remove('high-contrast');
    }
    
    // Apply reduced motion
    if (reducedMotion) {
      document.documentElement.classList.add('reduced-motion');
      document.body.classList.add('reduced-motion');
    } else {
      document.documentElement.classList.remove('reduced-motion');
      document.body.classList.remove('reduced-motion');
    }
    
    // Apply font size to all iframes as well
    const iframes = document.querySelectorAll('iframe');
    iframes.forEach(iframe => {
      try {
        if (iframe.contentDocument) {
          iframe.contentDocument.documentElement.setAttribute('data-font-size', fontSize);
          if (highContrast) {
            iframe.contentDocument.documentElement.classList.add('high-contrast');
            iframe.contentDocument.body.classList.add('high-contrast');
          }
          if (reducedMotion) {
            iframe.contentDocument.documentElement.classList.add('reduced-motion');
            iframe.contentDocument.body.classList.add('reduced-motion');
          }
        }
      } catch (e) {
        // Ignore cross-origin iframe errors
      }
    });
  }, [fontSize, highContrast, reducedMotion]);

  const updateAccessibilitySettings = (settings) => {
    if (settings.fontSize) {
      setFontSize(settings.fontSize);
      localStorage.setItem('fontSize', settings.fontSize);
    }
    
    if (settings.highContrast !== undefined) {
      setHighContrast(settings.highContrast);
      localStorage.setItem('highContrast', settings.highContrast);
    }
    
    if (settings.reducedMotion !== undefined) {
      setReducedMotion(settings.reducedMotion);
      localStorage.setItem('reducedMotion', settings.reducedMotion);
    }
  };

  return (
    <AccessibilityContext.Provider value={{ 
      fontSize, 
      highContrast, 
      reducedMotion, 
      updateAccessibilitySettings 
    }}>
      {children}
    </AccessibilityContext.Provider>
  );
};

export default AccessibilityContext;
